import { render, staticRenderFns } from "./OrderDesktop.vue?vue&type=template&id=c3c30178&scoped=true&"
import script from "./OrderDesktop.vue?vue&type=script&lang=js&"
export * from "./OrderDesktop.vue?vue&type=script&lang=js&"
import style0 from "./OrderDesktop.vue?vue&type=style&index=0&id=c3c30178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c30178",
  null
  
)

export default component.exports